// Locked color scale for every status/reading pill (Status, Signal, Battery,
// Alert status) across all three tables -- same hex in light and dark mode
// (all four pass WCAG AA with dark text at 5.28:1 or better), so pills read
// consistently regardless of theme. Dark text everywhere, no white text
// tiers.
export const SENSOR_STATUS_COLOR = {
  positive: { background: "#66bb6a", color: "#0d1f0f" },
  good: { background: "#a5d6a7", color: "#0d1f0f" },
  caution: { background: "#ffa726", color: "#2b1900" },
  negative: { background: "#ef5350", color: "#2b0808" },
};
